import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {v4 as uuidv4} from 'uuid';
import {orgId, defaultErrorHandler} from '../../context/context';
import customFormsV2Client from '../../infrastructure/acerill/custom-forms-v2-client';
import Section from '../../libs/react-components-admin/section/section';
import CenteredSpinner from '../../libs/react-components-admin/spinners/centered-spinner';
import ActionButton from '../../libs/react-components-admin/buttons/action-button';
import DeleteButton from '../../libs/react-components-admin/buttons/delete-button';
import AddButton from '../../libs/react-components-admin/buttons/add-button';

const Forms = () => {

  const navigate = useNavigate();

  const [forms, setForms] = useState();

  const formComparator = (a, b) => {
    if (!a.name) {
      return -1;
    } else if (!b.name) {
      return 1;
    } else {
      return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
    }
  };

  useEffect(() => {
    customFormsV2Client
      .findAllForms()
      .then(forms => setForms(forms.sort(formComparator)))
      .catch(defaultErrorHandler);
  }, []);

  const goToForm = formId => new Promise(resolve => {
    navigate(`/forms/${encodeURIComponent(formId)}?shop=${encodeURIComponent(orgId)}`);
    resolve();
  });

  const createForm = () => customFormsV2Client.createDefaultForm()
    .then(createdForm => goToForm(createdForm.id));

  const cloneForm = id => customFormsV2Client.findFormById(id)
    .then(form => {
      form.id = uuidv4();
      form.name = form.name + ' - Copy';
      return customFormsV2Client.updateForm(form);
    })
    .then(savedForm => setForms([...forms, savedForm].sort(formComparator)));

  const deleteForm = id => customFormsV2Client.deleteForm(id)
    .then(() => setForms(forms.filter(form => form.id !== id)));

  return <Section title="Forms">
    {!forms ?
      <CenteredSpinner/> :
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 table-responsive">
          <table className="table">
            <tbody>
            {forms.map(form => {
              return <tr key={form.id}>
                <td className="col-7">
                  {form.name}<br/>
                  <span className="text-muted" style={{fontSize: '0.9em'}}>ID: {form.id}</span>
                </td>
                <td className="col-2">
                  <div className="d-grid">
                    <ActionButton className="btn-primary"
                                  action={() => goToForm(form.id)}
                                  errorHandler={defaultErrorHandler}>
                      Edit
                    </ActionButton>
                  </div>
                </td>
                <td className="col-2">
                  <div className="d-grid">
                    <ActionButton className="btn-light"
                                  action={() => cloneForm(form.id)}
                                  errorHandler={defaultErrorHandler}>
                      Clone
                    </ActionButton>
                  </div>
                </td>
                <td className="col-1">
                  <DeleteButton action={() => deleteForm(form.id)}
                                errorHandler={defaultErrorHandler}/>
                </td>
              </tr>;
            })}
            <tr>
              <td className="col-7 border-bottom-0"/>
              <td className="col-2 border-bottom-0"/>
              <td className="col-2 border-bottom-0"/>
              <td className="col-1 border-bottom-0">
                <AddButton action={() => createForm()}
                           errorHandler={defaultErrorHandler}/>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    }
  </Section>;
};

export default Forms;
